import { useParams, Navigate } from "react-router-dom";
import { SectionsPage } from "@/components/SectionsPage";
import { companyPages } from "@/data/company";

export default function CompanyPage() {
  const { slug } = useParams();
  const c = companyPages.find((x) => x.slug === slug);
  if (!c) return <Navigate to="/company/about" replace />;

  return (
    <SectionsPage
      seoTitle={c.seoTitle}
      seoDescription={c.seoDescription}
      path={`/company/${c.slug}`}
      back={{ to: "/", label: "Back to home" }}
      eyebrow="Company"
      title={c.title}
      subtitle={c.intro}
      sections={c.sections}
      note={c.note}
      cta={c.cta}
      testid={`company-${c.slug}`}
    />
  );
}
